/**
 * <ec-subcollections> — shows only the group named by the URL #hash and puts
 * its title ([data-ec-group-title]) in the banner ([data-ec-banner-title],
 * back to its data-default text when every group is shown).
 *
 * Groups are [data-ec-group="id"] (scoped menus: "scope--title-handle").
 * The hash matches a group id exactly (case-insensitive); if none does, groups whose title handle
 * ([data-ec-group-key]) equals it. No hash or no match: every group is shown.
 * Group elements use "ec-group-" ids, so the browser never jumps to them; on
 * hashchange (a header link to the same page) the page scrolls to the top.
 */
if (!customElements.get('ec-subcollections')) {
  class EcSubcollections extends HTMLElement {
    connectedCallback() {
      this.groups = Array.from(this.querySelectorAll('[data-ec-group]'));
      this.bannerTitle = this.querySelector('[data-ec-banner-title]');
      this.onHashChange = () => {
        this.update();
        window.scrollTo({ top: 0, behavior: 'auto' });
      };
      window.addEventListener('hashchange', this.onHashChange);
      this.update();
    }

    disconnectedCallback() {
      window.removeEventListener('hashchange', this.onHashChange);
    }

    currentHash() {
      try {
        return decodeURIComponent(window.location.hash.slice(1)).trim().toLowerCase();
      } catch (error) {
        return window.location.hash.slice(1).trim().toLowerCase();
      }
    }

    update() {
      const hash = this.currentHash();
      let matches = [];
      if (hash) {
        matches = this.groups.filter((group) => group.dataset.ecGroup === hash);
        if (!matches.length) matches = this.groups.filter((group) => group.dataset.ecGroupKey === hash);
      }
      const showAll = matches.length === 0;
      this.groups.forEach((group) => {
        group.hidden = !showAll && !matches.includes(group);
      });
      this.classList.toggle('is-filtered', !showAll);
      if (this.bannerTitle) {
        this.bannerTitle.textContent = showAll
          ? this.bannerTitle.dataset.default || ''
          : matches[0].dataset.ecGroupTitle;
      }
    }
  }

  customElements.define('ec-subcollections', EcSubcollections);
}
